import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M6045 11904 c-22 -2 -103 -8 -180 -14 -529 -41 -1085 -178 -1595
-393 -161 -68 -455 -212 -570 -279 -41 -25 -90 -53 -109 -64 -146 -83 -461
-308 -631 -448 -881 -731 -1521 -1746 -1790 -2841 -117 -480 -159 -804 -165
-1290 l-3 -280 8 245 c23 741 148 1340 411 1977 62 150 183 404 245 513 116
205 220 378 235 390 3 3 12 16 19 30 45 85 306 422 454 585 903 999 2081 1594
3387 1710 208 19 607 21 809 5 726 -58 1477 -290 2100 -650 115 -66 278 -167
290 -180 3 -3 32 -23 65 -44 73 -48 229 -163 310 -229 187 -154 218 -182 353
-312 187 -180 303 -304 433 -460 418 -505 756 -1113 958 -1724 134 -404 214
-789 258 -1231 23 -241 23 -777 0 -1016 -32 -315 -106 -726 -172 -949 -15 -49
-34 -115 -42 -145 -87 -322 -348 -931 -511 -1195 -17 -27 -39 -63 -48 -80 -90
-163 -291 -453 -442 -639 -125 -154 -120 -158 9 -9 268 311 528 701 724 1087
335 660 528 1336 597 2086 17 191 17 779 0 965 -68 721 -244 1350 -551 1965
-625 1252 -1692 2202 -2971 2642 -372 128 -742 210 -1145 254 -131 14 -650 27
-740 18z"/>
<path d="M5285 10293 c-375 -46 -614 -140 -851 -334 -301 -246 -463 -637 -415
-1004 39 -301 163 -539 405 -780 204 -202 380 -326 941 -662 383 -229 580
-355 665 -424 30 -25 66 -52 80 -62 13 -9 73 -62 132 -118 l108 -100 1 -97 c0
-76 2 -92 10 -72 6 14 9 50 6 80 l-4 54 49 -54 c140 -152 269 -396 318 -602
13 -54 26 -98 30 -98 13 0 221 72 424 148 l208 77 -5 60 c-20 210 -145 501
-309 724 -97 131 -297 330 -446 441 -37 28 -76 59 -87 69 -11 10 -60 44 -110
77 -49 32 -92 61 -95 64 -26 27 -378 240 -750 455 -397 229 -570 343 -735 486
-139 120 -205 198 -281 334 -76 134 -108 256 -108 410 0 305 188 572 508 719
157 73 317 101 529 94 392 -14 711 -183 962 -508 110 -143 196 -308 290 -558
15 -40 29 -71 31 -69 3 2 5 206 4 453 l0 449 -22 15 c-29 20 -264 125 -361
161 -212 79 -498 148 -695 168 -96 10 -359 13 -427 4z m422 -29 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-807 -78 c0 -2 -7 -7 -16 -10 -8 -3
-12 -2 -9 4 6 10 25 14 25 6z m-181 -90 c-2 -2 -15 -7 -29 -10 l-25 -7 25 15
c21 12 42 14 29 2z m-69 -36 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10 8 5 20 10
25 10 6 0 3 -5 -5 -10z m-69 -40 c-13 -11 -28 -20 -34 -20 -13 0 -4 9 25 26
33 18 36 16 9 -6z m-88 -72 c-27 -24 -62 -54 -78 -68 -17 -14 -42 -42 -57 -62
-15 -20 -34 -42 -41 -50 -7 -7 -28 -35 -47 -63 -19 -27 -37 -52 -40 -55 -11
-11 -90 -178 -104 -221 -23 -67 -56 -233 -57 -288 l-2 -46 -7 50 c-9 60 2 155
30 250 23 80 124 287 152 311 10 10 18 21 18 26 0 11 76 94 139 152 99 93 116
106 128 106 8 0 -8 -19 -34 -42z m-426 -930 c-2 -13 -4 -3 -4 22 0 25 2 35 4
23 2 -13 2 -33 0 -45z m1738 -1058 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0
13 -4 16 -10z m65 -40 c0 -5 9 -10 19 -10 11 0 21 -3 23 -7 2 -5 19 -16 38
-26 64 -33 80 -44 73 -51 -4 -4 0 -4 8 -1 9 3 22 -1 29 -10 7 -8 16 -15 21
-15 5 0 46 -22 90 -50 44 -27 84 -50 89 -50 4 0 13 -7 21 -16 7 -8 33 -26 58
-39 25 -13 59 -36 76 -50 16 -15 56 -42 87 -61 32 -20 58 -39 58 -44 0 -5 7
-7 15 -4 9 4 15 0 15 -8 0 -8 28 -35 63 -61 80 -58 288 -268 329 -330 17 -26
34 -47 39 -47 5 0 9 -7 9 -15 0 -8 4 -15 10 -15 14 0 32 -40 26 -57 -5 -12
-12 -6 -31 21 -14 20 -25 39 -25 43 0 18 -326 325 -441 414 -127 99 -381 279
-394 279 -3 0 -16 9 -28 20 -12 12 -51 37 -87 57 -36 20 -66 40 -68 45 -2 4
-7 8 -12 8 -9 0 -130 80 -130 86 0 2 5 4 10 4 6 0 10 -4 10 -10z m5 -625 c19
-15 18 -15 -12 -1 -17 9 -35 21 -39 27 -8 13 21 -1 51 -26z m225 -150 c122
-90 130 -97 130 -113 0 -7 4 -11 8 -8 9 6 172 -149 172 -163 0 -5 -36 26 -81
70 -44 43 -83 79 -86 79 -2 0 -23 16 -46 35 -68 57 -120 97 -201 155 -42 30
-76 58 -76 63 0 10 63 -32 180 -118z m999 -240 c0 -5 -4 -3 -9 5 -5 8 -9 22
-9 30 0 16 17 -16 18 -35z m-664 -65 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0
6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M7046 6977 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M9349 9555 c0 0 -3 -51 -5 -112 l-5 -113 116 0 116 0 -3 112 -3 113
-107 0 c-60 0 -108 0 -109 0z"/>
<path d="M9823 9065 c4 -39 2 -55 -6 -55 -7 0 -6 -4 3 -10 11 -7 6 -10 -20
-10 -24 0 -31 3 -21 9 11 7 11 9 0 13 -8 3 -23 2 -33 0 -20 -5 -20 -5 0 -13
12 -6 1 -8 -33 -7 -29 1 -56 -1 -59 -5 -4 -4 36 -7 89 -7 l97 0 0 70 c0 46 -4
70 -11 70 -8 0 -10 -17 -6 -55z"/>
<path d="M5992 8839 c170 -41 282 -133 333 -274 17 -44 19 -92 23 -408 l4
-358 56 -37 c31 -20 62 -41 69 -47 6 -5 27 -20 45 -33 18 -12 73 -52 123 -89
49 -36 83 -58 76 -49 -20 24 -192 153 -278 209 l-72 47 -3 373 c-3 352 -4 375
-24 427 -12 30 -25 64 -29 75 -7 17 -5 17 13 -4 21 -23 41 -81 61 -179 6 -29
11 -130 11 -225 l1 -172 20 38 c21 39 36 47 45 22 13 -32 34 -16 34 25 0 28 4
40 14 40 8 0 16 7 20 15 9 24 26 18 26 -9 0 -22 2 -23 25 -13 20 10 25 19 25
50 0 43 27 53 32 12 l3 -26 33 30 c23 22 32 39 32 63 0 25 3 29 10 18 8 -13
10 -12 10 3 0 20 16 23 23 5 3 -7 6 10 7 37 1 28 5 59 9 70 7 18 8 18 14 -5 3
-14 9 -240 13 -503 l6 -479 -22 12 c-12 6 -24 9 -28 6 -3 -3 0 -6 6 -6 6 0 20
-10 32 -22 l20 -22 0 621 c0 595 1 622 19 644 17 22 28 24 129 27 142 5 347
-12 503 -42 601 -116 1092 -555 1332 -1191 47 -126 100 -313 117 -417 5 -33
12 -63 15 -66 3 -3 13 2 23 12 18 15 18 21 6 86 -58 304 -181 604 -355 864
-218 325 -543 579 -897 701 -64 22 -88 34 -77 39 10 3 23 3 29 -2 15 -11 93
-34 133 -39 40 -4 53 15 25 38 -12 9 -22 26 -22 38 0 16 -8 21 -37 26 -21 3
-49 8 -63 10 -138 25 -362 33 -965 34 -363 1 -668 6 -690 11 -22 5 -58 9 -80
9 -35 -1 -30 -4 37 -20z m1635 -35 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1
17 -2 13 -5z m46 -11 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m80 -20 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-286 -9 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m71 -11 c-10 -2 -28 -2 -40
0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z m59 -19 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z m160 0 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z"/>
<path d="M9304 8771 c-2 -2 -4 -73 -4 -158 l0 -153 155 0 155 0 0 158 0 158
-151 -1 c-83 0 -153 -2 -155 -4z"/>
<path d="M7850 8760 c0 -5 12 -10 26 -10 14 0 23 4 19 10 -3 6 -15 10 -26 10
-10 0 -19 -4 -19 -10z"/>
<path d="M7840 8720 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M8920 8495 l0 -106 103 3 102 3 3 103 3 102 -106 0 -105 0 0 -105z"/>
<path d="M9217 8253 c-4 -3 -7 -51 -7 -105 l0 -98 104 0 104 0 7 94 c4 52 4
99 1 105 -8 12 -198 16 -209 4z"/>
<path d="M4112 7994 c-59 -66 -60 -67 -92 -55 -132 46 -250 -63 -206 -189 9
-27 12 -49 6 -59 -5 -9 -114 -121 -243 -249 l-234 -232 -37 15 c-98 41 -195
-38 -182 -149 3 -28 2 -55 -2 -61 -4 -5 -41 -39 -82 -75 -41 -35 -77 -67 -80
-70 -3 -3 -32 -28 -65 -55 -33 -27 -88 -76 -123 -107 -34 -32 -68 -58 -75 -58
-7 1 -23 7 -37 15 -62 36 -153 5 -189 -64 -19 -36 -17 -104 5 -142 41 -70 140
-94 203 -50 55 40 86 124 61 171 -10 19 12 41 215 216 44 38 100 88 125 111
90 82 89 82 131 65 103 -40 207 56 177 165 l-10 36 249 249 c173 173 253 246
263 242 8 -4 35 -8 60 -11 97 -10 179 88 151 181 -7 22 -15 50 -17 61 -4 15
11 42 51 93 31 40 52 72 47 72 -5 0 -37 -30 -70 -66z m-90 -89 c19 -14 19 -16
3 -10 -72 29 -129 12 -165 -48 -14 -23 -20 -27 -20 -14 0 52 63 101 122 94 20
-3 47 -13 60 -22z m-722 -706 c0 -6 -9 -8 -20 -4 -30 10 -87 -13 -109 -43 -11
-15 -21 -22 -21 -15 0 6 14 25 31 42 25 25 39 31 75 31 24 0 44 -5 44 -11z
m-631 -565 c15 -16 15 -16 -4 -9 -66 26 -122 12 -155 -39 -12 -19 -20 -25 -20
-15 0 22 37 68 64 80 30 13 96 3 115 -17z"/>
<path d="M9601 7923 c49 -115 37 -263 -33 -398 -184 -358 -734 -752 -1624
-1164 -137 -63 -242 -116 -209 -105 56 18 81 29 93 41 12 12 32 18 32 9 0 -1
-5 -17 -11 -35 -10 -29 -29 -43 -29 -21 0 14 -30 12 -61 -4 -14 -7 -37 -16
-52 -20 -25 -6 -38 -26 -17 -26 5 0 7 -7 3 -16 -3 -9 0 -20 8 -24 7 -5 10 -13
5 -17 -5 -4 -11 -2 -13 5 -7 18 -50 15 -57 -4 -5 -13 -1 -15 21 -10 21 5 24 4
13 -4 -21 -14 3 -13 37 2 15 7 30 15 33 18 3 3 30 13 60 24 30 10 77 29 105
42 27 12 84 37 125 54 145 61 432 195 538 252 239 127 348 188 463 258 115 71
236 153 249 170 3 3 25 20 50 37 48 34 120 99 120 110 0 3 -8 -1 -19 -11 -15
-14 -20 -14 -30 -2 -9 11 -8 15 4 20 9 3 13 2 10 -4 -3 -6 -2 -10 4 -10 5 0
12 4 16 10 3 5 11 7 18 4 21 -8 169 157 234 259 44 70 75 174 75 252 0 80 -19
146 -65 226 -34 59 -105 149 -118 149 -4 0 6 -30 22 -67z m146 -255 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-23 -183 c-4 -8 -8 -15 -10 -15
-2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z m-159 -244 c3 -5 1 -12 -5
-16 -5 -3 -10 1 -10 9 0 18 6 21 15 7z m-95 -116 c0 -2 -9 -3 -19 -2 -11 0
-18 5 -15 9 4 6 34 0 34 -7z m-160 -129 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9
4 6 10 25 14 25 6z m-1370 -740 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5
11 10 11 6 0 10 -2 10 -4z m-53 -23 c2 -6 -11 -16 -29 -22 -28 -9 -31 -9 -15
3 9 7 17 19 17 25 0 15 22 10 27 -6z m-80 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z m-52 -14 c-27 -12 -43 -12 -25 0 8 5 22 9 30 9 10 0 8 -3
-5 -9z m34 -36 c-7 -8 -18 -13 -24 -10 -7 2 -18 -1 -24 -7 -9 -9 -14 -8 -21 3
-10 16 6 24 56 26 20 2 23 -1 13 -12z"/>
<path d="M9235 7815 l6 -30 -19 22 c-20 22 -20 22 -25 2 -3 -12 -9 -19 -14
-16 -5 3 -27 -8 -51 -24 -23 -16 -47 -29 -52 -29 -6 0 -10 -18 -10 -40 0 -29
-4 -40 -15 -40 -8 0 -15 4 -15 9 0 5 -11 4 -25 -2 -20 -10 -25 -19 -25 -49 0
-34 -3 -38 -26 -38 -14 0 -23 -4 -20 -9 4 -5 1 -11 -6 -13 -7 -3 -12 -22 -12
-43 0 -21 -2 -33 -4 -26 -2 6 -8 11 -13 11 -12 0 -2 -59 22 -125 9 -27 20 -66
24 -85 4 -19 13 -54 21 -78 8 -23 14 -61 14 -82 0 -22 4 -40 9 -40 30 0 250
199 364 328 l46 53 -20 52 c-43 113 -92 216 -100 211 -5 -3 -7 1 -4 8 3 7 -9
33 -25 58 -28 42 -30 43 -25 15z m-28 -47 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
3 -3 4 -12 1 -19z m110 -150 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z"/>
<path d="M8270 7565 l0 -145 145 0 145 0 0 145 0 145 -145 0 -145 0 0 -145z"/>
<path d="M792 7410 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M933 7215 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z"/>
<path d="M761 7194 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M903 7145 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M8270 7050 l0 -130 130 0 130 0 0 130 0 130 -130 0 -130 0 0 -130z"/>
<path d="M752 7125 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M748 7050 c-7 -24 -3 -38 8 -28 3 4 4 17 2 30 l-3 23 -7 -25z"/>
<path d="M913 6965 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z"/>
<path d="M9531 6998 c-1 -10 -5 -17 -10 -15 -15 4 -71 -43 -71 -59 0 -8 -3
-13 -7 -11 -5 3 -24 -8 -43 -24 -39 -33 -32 -40 8 -8 l27 21 3 -21 c3 -17 11
-21 40 -22 20 -1 40 -1 45 0 4 0 7 -8 7 -18 0 -10 7 -22 16 -25 15 -6 16 1 11
66 -7 71 -24 151 -26 116z"/>
<path d="M743 6910 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z"/>
<path d="M7810 6770 l0 -150 150 0 150 0 0 150 0 150 -150 0 -150 0 0 -150z"/>
<path d="M892 6880 c0 -8 4 -26 8 -40 6 -20 8 -21 8 -5 0 11 -3 29 -8 40 -5
12 -8 14 -8 5z"/>
<path d="M9327 6837 c-15 -12 -47 -38 -72 -57 -25 -19 -40 -37 -34 -39 6 -2
22 8 35 22 16 18 30 24 45 20 14 -4 20 -2 16 4 -4 7 7 6 33 0 43 -12 56 -7 46
19 -5 13 -14 15 -38 10 -31 -6 -31 -6 -13 14 26 29 14 33 -18 7z"/>
<path d="M9170 6725 c-7 -8 -8 -15 -2 -15 5 0 15 7 22 15 7 8 8 15 2 15 -5 0
-15 -7 -22 -15z"/>
<path d="M903 6620 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z"/>
<path d="M9065 6659 c-16 -10 -25 -19 -20 -19 6 0 24 9 40 20 17 11 26 20 20
19 -5 0 -23 -9 -40 -20z"/>
<path d="M8978 6616 c-15 -11 -18 -29 -18 -92 -1 -539 -202 -1082 -535 -1441
-221 -238 -495 -400 -800 -473 -158 -38 -255 -51 -455 -60 l-165 -8 195 4
c107 2 227 8 265 14 101 15 266 57 365 92 74 26 296 132 310 148 9 10 79 60
83 60 15 0 232 208 303 290 85 99 230 343 292 490 104 250 164 510 180 785 10
157 10 205 2 205 -3 0 -13 -7 -22 -14z"/>
<path d="M894 6383 c4 -38 11 -90 16 -118 9 -49 9 -49 5 14 -3 35 -5 88 -5
117 0 34 -4 54 -11 54 -9 0 -10 -19 -5 -67z"/>
<path d="M751 6325 c0 -11 4 -29 9 -40 8 -18 9 -18 9 5 0 14 -4 32 -9 40 -8
12 -10 12 -9 -5z"/>
<path d="M738 6260 c2 -22 6 -40 8 -40 2 0 4 18 4 40 0 22 -3 40 -8 40 -4 0
-6 -18 -4 -40z"/>
<path d="M2443 6218 c-15 -18 -35 -58 -29 -58 2 0 13 16 25 35 20 35 22 46 4
23z"/>
<path d="M762 6200 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M792 6200 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M743 6165 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M7655 6190 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M911 6154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2384 6139 c-4 -7 -3 -9 4 -5 5 3 13 0 15 -6 4 -9 6 -10 6 -1 1 17
-16 25 -25 12z"/>
<path d="M881 6104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7625 6110 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M2361 6083 c1 -16 -1 -44 -5 -63 -6 -26 -5 -32 3 -24 17 15 27 114
12 114 -6 0 -11 -12 -10 -27z"/>
<path d="M917 6071 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
<path d="M2325 6035 c-11 -19 -16 -37 -13 -40 3 -4 14 10 23 30 23 47 14 56
-10 10z"/>
<path d="M752 6040 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M881 6044 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7468 6043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7430 6030 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M933 5965 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M902 5960 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M2352 5960 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M762 5950 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M2281 5914 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M772 5901 c-8 -5 -8 -26 2 -86 l14 -80 -5 85 c-3 62 -2 81 6 70 7 -9
11 -10 11 -3 0 16 -13 23 -28 14z"/>
<path d="M7352 5879 c-18 -17 -419 -164 -794 -292 l-208 -70 0 -345 c0 -344 0
-345 20 -327 22 20 27 30 9 19 -8 -4 -10 67 -7 251 1 141 6 259 9 261 7 4 19
-150 19 -248 0 -67 1 -68 21 -58 16 9 24 8 39 -5 17 -15 19 -15 24 2 3 10 4 2
3 -18 -2 -27 1 -35 10 -32 7 3 14 15 14 27 1 18 2 18 6 3 3 -10 -3 -27 -13
-38 -9 -10 -12 -19 -7 -19 6 0 19 12 29 28 10 15 24 33 31 41 8 7 12 20 9 28
-3 8 -2 12 3 9 5 -3 16 5 24 18 38 57 132 245 153 304 12 35 24 59 28 54 7
-12 -27 -176 -55 -260 -81 -247 -262 -457 -496 -576 -68 -34 -185 -70 -298
-92 -108 -21 -369 -24 -490 -5 -363 57 -679 205 -921 434 l-82 77 -44 -9
c-149 -33 -573 -71 -792 -71 -359 0 -638 49 -886 155 -105 45 -164 85 -127 85
8 0 17 -4 19 -8 10 -24 169 -80 321 -113 322 -69 823 -65 1347 12 181 26 488
84 630 119 63 15 133 31 155 35 22 4 44 10 50 13 5 3 16 7 25 8 20 3 202 53
215 59 12 6 -47 -4 -100 -17 -22 -5 -49 -11 -60 -12 -11 -2 -28 -7 -38 -11
-10 -4 -23 -3 -29 3 -8 8 -5 9 9 6 12 -3 24 -1 27 5 4 6 16 11 26 11 10 0 22
4 25 10 3 5 0 7 -8 4 -10 -3 -17 4 -21 20 -3 14 -11 26 -16 26 -6 0 -10 10
-10 21 0 17 -4 20 -22 15 -48 -14 -276 -55 -329 -60 -30 -3 -69 -7 -85 -11
-23 -4 -25 -3 -9 4 22 11 -34 7 -116 -9 -221 -43 -758 -98 -984 -101 -63 -1
-81 -4 -60 -9 44 -11 -291 -12 -356 -1 -30 6 -92 13 -138 16 -46 3 -93 11
-103 16 -11 6 -24 8 -31 5 -7 -2 -4 -5 6 -5 25 -1 21 -14 -13 -33 -17 -9 -30
-24 -30 -33 0 -9 -9 -15 -22 -16 -22 -1 -22 -1 2 -9 l25 -8 -27 -1 c-36 -1
-36 -18 0 -24 26 -4 25 -4 -5 -6 -17 0 -38 6 -46 14 -11 11 -17 11 -19 3 -3
-8 -22 -5 -64 11 -84 33 -215 100 -240 122 -11 11 -24 19 -28 19 -14 0 -76 72
-120 140 -56 85 -77 146 -86 250 l-8 85 2 -90 c9 -303 245 -534 750 -735 594
-236 1718 -493 2362 -540 510 -37 913 39 1268 241 398 226 680 631 761 1090
21 119 20 148 -5 146 -11 -1 -24 -4 -28 -8z m-4372 -659 c0 -5 -4 -10 -10 -10
-5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-2 -47 c-2 -11 -13 -19
-28 -20 -15 -1 -18 0 -7 3 9 3 17 12 17 20 0 8 5 14 11 14 6 0 9 -8 7 -17z
m3625 -8 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-3476 -81
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M967 5720 c3 -30 7 -57 9 -59 8 -9 2 75 -6 94 -5 12 -6 -1 -3 -35z"/>
<path d="M792 5695 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M981 5634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M815 5570 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"/>
<path d="M821 5538 c-1 -19 59 -321 65 -327 8 -9 3 25 -26 173 -32 160 -38
181 -39 154z"/>
<path d="M1002 5520 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M861 5484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1010 5455 c0 -19 4 -35 8 -35 4 0 6 16 4 35 -2 19 -6 35 -8 35 -2 0
-4 -16 -4 -35z"/>
<path d="M1042 5325 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9130 5309 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8690 5279 c0 -11 -4 -17 -10 -14 -5 3 -10 1 -10 -4 0 -6 7 -11 15
-11 9 0 15 9 15 25 0 14 -2 25 -5 25 -3 0 -5 -9 -5 -21z"/>
<path d="M9147 5268 c-15 -26 -20 -29 -28 -17 -8 10 -9 9 -4 -8 4 -16 0 -25
-14 -32 -13 -7 -22 -8 -26 -1 -10 16 -22 12 -28 -10 -4 -16 -14 -20 -45 -20
-22 0 -42 5 -44 11 -2 7 -54 12 -148 14 -129 2 -142 1 -124 -12 18 -14 17 -15
-10 -10 -30 5 -56 -11 -56 -34 0 -9 -3 -10 -11 -2 -7 7 -1 20 20 44 17 18 31
37 31 41 0 17 -16 6 -41 -30 -29 -40 -132 -155 -163 -181 -10 -9 -43 -38 -74
-66 -111 -101 -297 -222 -422 -273 -30 -13 -64 -27 -75 -33 -39 -18 -139 -49
-219 -68 -178 -42 -226 -46 -504 -46 l-273 0 -29 34 c-18 20 -30 45 -30 62 0
16 -2 29 -5 29 -3 0 -35 -21 -72 -46 -84 -57 -202 -118 -290 -149 l-68 -23
472 -1 c814 -1 1039 23 1398 149 179 63 350 157 545 302 57 42 216 199 260
258 19 25 37 47 40 50 15 13 70 100 63 100 -4 0 -16 -14 -26 -32z m-67 -88 c0
-5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z"/>
<path d="M2878 5273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9080 5240 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M901 5174 c0 -16 4 -38 9 -49 6 -14 8 -8 6 23 -4 49 -16 71 -15 26z"/>
<path d="M942 5110 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M11391 5074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M936 5017 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M11451 4804 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M11445 4769 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M11310 4710 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M11271 4674 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M11377 4593 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M6928 4553 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M11359 4544 c-1 -5 -2 -13 -3 -19 0 -5 -8 -21 -15 -35 -8 -14 -16
-35 -17 -48 -2 -12 -10 -36 -18 -54 -9 -17 -16 -36 -16 -42 1 -18 39 67 46
102 3 17 10 32 14 32 10 0 24 59 16 67 -3 4 -7 2 -7 -3z"/>
<path d="M11310 4520 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M11270 4471 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M11291 4424 c-6 -21 -9 -40 -6 -42 2 -2 8 13 14 34 6 21 9 40 6 42
-2 2 -8 -13 -14 -34z"/>
<path d="M11151 4364 c-12 -31 -20 -58 -18 -60 5 -5 22 32 36 75 18 57 4 46
-18 -15z"/>
<path d="M11180 4363 c0 -12 -4 -25 -10 -28 -12 -7 -14 -35 -2 -35 13 0 30 57
21 71 -6 10 -9 8 -9 -8z"/>
<path d="M11198 4298 c7 -7 12 -19 12 -27 0 -14 -1 -14 -10 -1 -12 19 -35 -2
-27 -24 9 -24 36 -19 49 8 8 20 7 28 -5 40 -9 9 -19 16 -23 16 -5 0 -3 -5 4
-12z"/>
<path d="M11233 4244 c-15 -23 -20 -41 -15 -55 7 -16 11 -11 26 31 10 28 17
52 15 54 -2 2 -14 -12 -26 -30z"/>
<path d="M11085 4219 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M11063 4165 c-8 -18 -8 -25 0 -25 6 0 1 -9 -11 -20 -31 -29 -27 -43
7 -25 36 18 44 30 47 70 l3 30 -11 -27 c-12 -35 -31 -37 -22 -3 8 32 2 32 -13
0z"/>
<path d="M11203 4150 c0 -23 3 -28 9 -16 5 9 5 23 0 32 -6 12 -9 7 -9 -16z"/>
<path d="M11120 4126 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z"/>
<path d="M2700 4115 c-129 -36 -195 -153 -160 -280 19 -66 56 -112 167 -205
54 -46 115 -106 137 -134 36 -48 38 -54 34 -112 -3 -46 -10 -68 -28 -92 -92
-114 -293 -57 -316 90 -10 61 -21 45 -29 -41 -9 -106 -6 -115 61 -136 84 -26
200 -23 267 8 61 28 117 90 137 151 17 52 8 151 -18 201 -22 43 -108 130 -182
185 -103 77 -150 137 -150 194 1 45 38 106 74 121 100 42 236 -18 236 -103 0
-12 5 -24 10 -27 6 -4 10 14 10 48 0 30 3 68 6 84 6 29 4 31 -40 42 -80 20
-157 22 -216 6z"/>
<path d="M11156 4059 c-21 -46 -24 -49 -29 -28 -4 13 -7 34 -7 47 0 27 -14 28
-42 2 -12 -11 -17 -20 -11 -20 6 0 14 -12 17 -26 4 -16 12 -24 21 -21 7 3 16
-2 20 -11 3 -9 1 -18 -4 -20 -6 -2 -8 -8 -5 -14 6 -10 56 81 67 122 9 35 -2
22 -27 -31z"/>
<path d="M11130 4069 c0 -11 4 -18 10 -14 5 3 7 12 3 20 -7 21 -13 19 -13 -6z"/>
<path d="M11000 4017 c-14 -29 -29 -55 -35 -59 -5 -4 -6 -10 -2 -14 9 -9 37
15 37 33 0 8 7 30 16 49 9 19 15 36 13 38 -2 3 -15 -19 -29 -47z"/>
<path d="M11079 3963 c12 -24 31 -39 31 -25 0 5 -10 17 -21 28 -22 19 -22 19
-10 -3z"/>
<path d="M4457 3963 c-9 -16 -18 -72 -57 -382 -42 -332 -50 -361 -95 -361 -14
0 -25 -4 -25 -8 0 -5 50 -9 110 -9 61 0 110 4 110 9 0 4 -11 8 -24 8 -48 0
-49 12 -26 262 11 128 22 239 23 247 1 8 63 -106 137 -254 74 -148 140 -270
146 -272 8 -3 149 277 246 490 22 48 38 60 38 30 1 -10 11 -121 24 -246 13
-126 22 -237 19 -246 -4 -15 5 -19 58 -24 90 -10 149 -8 149 3 0 6 -13 10 -28
10 -29 0 -72 31 -72 53 -1 41 -88 679 -94 684 -3 4 -10 2 -16 -3 -9 -9 -172
-336 -250 -502 -24 -51 -47 -89 -51 -85 -4 5 -73 139 -154 298 -80 160 -150
294 -154 298 -5 5 -11 5 -14 0z"/>
<path d="M5857 3958 c-3 -7 -66 -166 -141 -353 -141 -352 -159 -385 -212 -385
-13 0 -24 -4 -24 -9 0 -4 52 -8 115 -8 63 1 115 5 115 9 0 4 -9 8 -20 8 -26 0
-39 26 -30 65 11 51 62 179 74 187 5 4 61 6 124 5 l115 -2 44 -115 c35 -90 42
-119 34 -132 -6 -10 -11 -19 -11 -21 0 -1 52 -3 116 -4 117 -2 131 2 71 22
-41 13 -65 50 -121 187 -25 62 -71 174 -101 248 -31 74 -70 169 -86 210 -33
83 -53 110 -62 88z m47 -298 c25 -70 46 -129 46 -133 0 -4 -45 -7 -101 -7
l-101 0 6 25 c17 68 90 255 96 248 4 -4 29 -64 54 -133z"/>
<path d="M11010 3960 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M8509 3913 c-11 -26 -70 -171 -130 -322 -146 -365 -150 -371 -208
-371 -12 0 -21 -4 -21 -9 0 -4 52 -8 115 -7 63 0 115 4 115 8 0 5 -8 8 -19 8
-39 0 -45 24 -22 99 12 39 30 91 41 116 l20 46 121 -3 121 -3 45 -115 c35 -90
42 -119 34 -132 -6 -10 -11 -20 -11 -23 0 -3 50 -5 110 -5 67 0 110 4 110 10
0 6 -11 10 -24 10 -16 0 -35 12 -53 35 -29 36 -51 85 -206 469 -51 126 -98
231 -105 234 -7 2 -21 -17 -33 -45z m59 -238 c64 -173 70 -155 -47 -155 -56 0
-101 4 -101 9 0 24 94 271 100 264 4 -4 26 -57 48 -118z"/>
<path d="M3285 3940 c3 -5 17 -10 29 -10 13 0 28 -6 34 -12 6 -8 12 -115 14
-263 4 -235 5 -253 27 -303 46 -103 146 -162 276 -162 149 0 244 67 285 200 9
30 15 126 19 285 l6 240 35 17 35 17 -118 1 c-76 0 -116 -4 -112 -10 3 -5 17
-10 29 -10 13 0 29 -6 35 -13 17 -21 19 -458 3 -523 -15 -58 -59 -117 -105
-141 -50 -25 -133 -22 -192 7 -42 21 -55 35 -80 85 l-30 60 -3 242 c-4 252 0
283 38 283 10 0 22 5 25 10 4 6 -40 10 -125 10 -85 0 -129 -4 -125 -10z"/>
<path d="M6440 3927 c47 -23 75 -59 203 -263 87 -139 90 -149 85 -291 -5 -130
-13 -153 -54 -153 -13 0 -24 -4 -24 -8 0 -4 61 -8 135 -8 74 0 135 4 135 8 0
4 -10 8 -22 8 -53 1 -67 41 -68 193 0 115 2 122 105 293 99 165 129 202 179
224 l41 19 -109 0 -110 1 23 -21 c29 -27 26 -34 -71 -204 -89 -155 -89 -155
-95 -138 -2 6 -32 58 -67 115 -34 57 -75 127 -91 156 l-29 54 24 19 c25 18 24
19 -105 18 l-130 0 45 -22z"/>
<path d="M7350 3940 c0 -5 10 -10 23 -10 39 0 89 -67 241 -323 l59 -98 -5
-129 c-5 -138 -13 -160 -54 -160 -13 0 -24 -4 -24 -8 0 -5 61 -9 135 -9 74 0
135 4 135 8 0 5 -13 9 -29 9 -52 0 -61 27 -61 173 0 147 -2 142 122 346 79
130 108 165 158 191 l35 19 -102 1 c-62 0 -103 -4 -103 -10 0 -5 6 -10 14 -10
31 0 22 -41 -28 -132 -85 -157 -121 -218 -126 -218 -3 0 -23 31 -44 68 -22 37
-60 103 -86 147 -64 109 -66 116 -38 137 22 17 20 18 -99 18 -76 0 -123 -4
-123 -10z"/>
<path d="M9180 3938 c51 -21 55 -26 63 -79 12 -74 1 -593 -13 -619 -6 -12 -21
-20 -35 -20 -14 0 -25 -4 -25 -8 0 -4 61 -9 135 -9 74 -1 135 3 135 7 0 5 -15
10 -32 12 -50 5 -58 30 -58 206 l0 152 200 0 200 0 0 -158 c0 -168 -8 -202
-51 -202 -10 0 -19 -4 -19 -8 0 -5 59 -8 130 -9 72 0 130 4 130 9 0 4 -13 8
-29 8 -54 0 -56 7 -59 324 -2 160 1 309 5 331 7 32 16 44 43 57 35 17 34 17
-100 17 -117 0 -131 -2 -102 -12 18 -7 37 -19 42 -27 5 -8 10 -75 10 -147 l0
-133 -200 0 -200 0 0 131 c0 136 8 169 40 169 10 0 22 5 25 10 4 6 -41 10
-127 9 -102 0 -127 -3 -108 -11z"/>
<path d="M10980 3931 c0 -5 4 -12 9 -15 15 -9 -5 -139 -20 -133 -4 1 -16 -6
-27 -16 -12 -11 -26 -15 -37 -11 -15 6 -13 11 16 35 30 25 32 28 12 29 -16 0
-20 5 -17 23 4 20 4 20 -4 2 -5 -11 -7 -26 -5 -32 3 -7 -1 -13 -9 -13 -8 0
-24 -19 -37 -42 -30 -59 -44 -82 -56 -90 -5 -4 -6 -8 -1 -8 5 0 18 7 28 17 20
18 25 4 6 -16 -7 -6 -13 -26 -13 -44 0 -25 -4 -32 -18 -30 -15 1 -18 -4 -13
-25 5 -22 4 -24 -5 -12 -9 12 -10 11 -6 -7 3 -13 1 -23 -4 -23 -20 0 -20 30 1
70 12 23 19 44 17 47 -3 2 -13 -13 -23 -34 -10 -21 -22 -41 -27 -44 -5 -4 -6
-17 -2 -30 5 -18 4 -20 -4 -9 -12 17 -10 19 -51 -50 -19 -30 -40 -63 -48 -72
-8 -10 -12 -24 -9 -33 4 -8 2 -25 -4 -37 l-10 -23 5 23 c6 32 -6 25 -48 -31
-31 -40 -35 -51 -25 -68 6 -11 8 -23 6 -26 -3 -2 -8 5 -12 16 -3 12 -11 19
-16 16 -13 -9 -11 -21 6 -39 14 -13 13 -15 -4 -13 -12 1 -17 6 -13 17 8 23
-28 -17 -62 -70 -24 -37 -187 -243 -206 -260 -3 -3 -21 -25 -40 -50 -19 -25
-41 -52 -49 -61 -9 -9 -52 -56 -96 -105 -156 -173 -298 -310 -543 -523 -183
-158 -585 -439 -822 -573 -573 -325 -1181 -538 -1765 -617 -297 -40 -380 -46
-665 -46 -274 1 -362 6 -615 41 -839 115 -1691 475 -2427 1026 -65 48 -146
111 -181 140 -35 29 -78 65 -95 79 -18 15 -55 48 -82 73 -29 28 -55 44 -61 40
-7 -4 -9 -3 -6 3 9 14 -29 47 -43 38 -17 -11 -39 13 -33 37 5 17 3 19 -15 13
-17 -5 -21 -3 -16 9 6 15 -16 46 -32 46 -5 0 -3 -5 4 -12 16 -16 15 -29 -1
-23 -6 3 -18 -5 -26 -17 -10 -18 -10 -20 0 -10 7 6 17 12 23 12 5 0 2 -6 -7
-12 -11 -9 -17 -29 -19 -61 -1 -26 -4 -43 -8 -37 -4 6 -14 8 -22 5 -9 -4 -19
-2 -23 4 -4 7 3 11 17 11 19 0 20 2 8 11 -11 7 -12 12 -3 15 7 3 9 12 6 21 -5
12 -3 14 7 8 8 -5 11 -3 8 6 -2 8 -19 15 -36 17 -18 2 -32 8 -32 13 0 6 -17 9
-39 8 -22 -2 -46 3 -55 10 -22 19 -20 5 3 -20 15 -16 23 -19 37 -11 23 13 58
-23 50 -51 -4 -17 32 -57 158 -172 90 -84 331 -277 456 -365 785 -560 1611
-878 2565 -987 226 -25 824 -26 1035 0 695 85 1196 235 1802 537 75 38 156 81
178 95 22 14 42 25 45 25 10 0 211 124 345 213 484 322 942 752 1329 1247 28
36 60 76 71 90 67 83 163 231 155 238 -3 4 -10 0 -15 -8 -7 -11 -10 -11 -10
-2 0 7 15 19 34 27 21 9 39 26 47 45 8 16 17 30 21 30 5 0 8 4 8 9 0 5 18 36
40 69 22 33 40 64 40 70 0 6 3 12 8 14 18 8 101 168 96 185 -5 15 -4 16 5 3 9
-12 13 -9 23 18 7 17 16 32 20 32 4 0 8 9 8 20 0 11 4 20 8 20 7 0 31 46 71
134 2 5 -1 6 -7 2 -13 -8 -42 -64 -42 -83 0 -7 -4 -13 -8 -13 -9 0 -52 -81
-52 -99 0 -6 -4 -11 -10 -11 -5 0 -10 7 -10 15 0 8 -6 15 -12 16 -7 0 -3 4 10
9 12 5 22 18 22 29 0 11 10 27 22 35 20 14 21 17 7 67 -8 29 -20 54 -26 57 -7
2 -13 -1 -13 -7z m-103 -263 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m42 -50 c-7 -13 -19 -34 -27 -48 l-14 -25 7 30 c4 17 11 32 16 33 5 2 9
10 9 18 0 8 5 14 10 14 7 0 6 -8 -1 -22z m-99 -171 c-22 -33 -22 -23 2 25 7
15 15 23 16 18 2 -6 -6 -25 -18 -43z m-140 -61 c0 -2 -7 -7 -16 -10 -8 -3 -12
-2 -9 4 6 10 25 14 25 6z m-83 -228 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m-7852 -857 c-6 -5 -25 10 -25 20 0 5 6 4 14 -3 8 -7 12 -15 11
-17z"/>
<path d="M11027 3933 c-4 -7 -3 -14 3 -18 5 -3 10 -16 10 -28 0 -18 3 -16 17
11 15 32 10 60 -6 33 -7 -11 -9 -11 -13 0 -3 9 -6 10 -11 2z"/>
<path d="M10956 3917 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M10941 3854 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6518 2823 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6507 2793 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M4830 2555 l-3 -70 -7 55 -7 55 -2 -45 c-2 -35 -4 -41 -11 -25 -6 14
-9 16 -11 5 -1 -8 -5 3 -9 25 -5 30 -8 16 -9 -60 -3 -143 -12 -187 -37 -200
-29 -14 283 -19 335 -5 48 13 134 67 126 80 -4 6 -1 9 6 8 14 -4 60 84 69 134
5 28 4 35 -7 31 -7 -3 -13 0 -13 7 0 7 -7 10 -15 6 -8 -3 -18 2 -23 10 -6 11
-11 -5 -15 -50 -7 -77 -35 -136 -79 -169 -63 -48 -174 -61 -238 -29 l-35 17
-5 145 c-4 105 -7 126 -10 75z"/>
<path d="M5981 2574 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6030 2555 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M6730 2535 l-3 -40 -6 35 c-5 26 -9 7 -15 -75 -4 -60 -8 -119 -9
-130 -1 -11 -12 -25 -25 -31 -18 -9 -3 -11 80 -10 57 1 92 2 78 4 -43 6 -50
27 -52 156 -1 67 -3 103 -6 81 -4 -36 -6 -38 -12 -15 -7 22 -8 20 -11 -15 -2
-35 -3 -32 -9 20 -6 53 -7 56 -10 20z"/>
<path d="M3713 2543 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M3798 2543 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M7402 2472 c-18 -46 -30 -88 -26 -94 4 -6 3 -8 -3 -5 -5 3 -17 -10
-26 -29 -10 -21 -30 -40 -47 -48 -28 -12 -24 -13 52 -13 56 -1 76 2 61 8 -36
13 -32 39 25 172 14 34 32 49 32 29 0 -5 24 -5 53 0 77 13 116 1 132 -42 7
-19 22 -60 33 -90 15 -39 17 -58 10 -67 -8 -10 4 -13 56 -13 36 0 66 2 66 5 0
3 -11 16 -24 28 -13 12 -38 58 -55 102 -41 104 -48 115 -61 95 -8 -12 -10 -10
-11 10 -1 15 -3 19 -6 9 -6 -23 -24 -26 -121 -21 -76 4 -83 6 -79 23 3 11 1
17 -4 13 -5 -3 -9 -13 -10 -22 -1 -10 -4 -7 -8 7 -6 21 -11 13 -39 -57z"/>
<path d="M8648 2543 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4123 2533 c48 -2 125 -2 170 0 45 1 6 3 -88 3 -93 0 -130 -2 -82 -3z"/>
<path d="M8258 2533 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M6026 2514 c-3 -7 -14 -10 -28 -7 -21 5 -21 4 -6 -8 21 -17 80 -177
73 -199 -4 -13 8 -15 78 -17 78 -1 81 -1 49 13 -28 11 -40 28 -73 101 -22 49
-45 97 -50 109 -12 23 -35 28 -43 8z m11 -46 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z"/>
<path d="M5771 2477 c-11 -27 -21 -53 -21 -57 0 -5 -13 -33 -29 -62 -22 -39
-38 -56 -63 -65 -30 -10 -28 -11 37 -10 l70 2 1 50 c0 28 9 68 19 90 10 22 19
43 19 47 2 15 18 21 73 28 l58 8 -67 -2 c-40 -1 -69 3 -72 9 -2 5 -13 -12 -25
-38z m5 -34 c-8 -15 -15 -25 -16 -21 0 12 23 58 27 54 3 -2 -2 -17 -11 -33z"/>
<path d="M2435 2449 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z"/>
<path d="M2500 2365 c0 -3 9 -14 21 -26 26 -26 39 -16 14 11 -17 19 -35 26
-35 15z"/>
<path d="M2745 2350 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4600 1773 c-48 -18 -66 -75 -34 -107 24 -24 80 -20 98 6 23 33 19
64 -10 87 -28 22 -30 23 -54 14z"/>
<path d="M7882 1768 c-44 -21 -42 -103 3 -114 64 -16 108 32 80 86 -9 17 -20
30 -24 30 -5 0 -15 2 -23 4 -7 3 -23 0 -36 -6z"/>
<path d="M6135 1729 c-38 -19 -66 -19 -695 -18 -360 0 -659 -1 -665 -2 -5 -2
294 -6 665 -9 660 -5 676 -5 715 -26 50 -26 82 -72 91 -130 8 -56 20 -56 28 0
9 55 40 104 86 130 34 21 50 21 708 24 369 1 672 6 672 10 0 6 -1459 0 -1469
-6 -2 -1 0 -13 3 -27 4 -14 2 -25 -4 -25 -5 0 -10 8 -10 19 0 24 -19 39 -58
47 -33 7 -41 19 -19 27 6 3 8 5 2 5 -5 0 -28 -8 -50 -19z m172 -53 c-3 -8 -1
-17 6 -20 7 -2 4 -5 -5 -5 -12 -1 -18 6 -18 19 0 11 5 20 11 20 6 0 9 -6 6
-14z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
